import { useAuth } from "../context/AuthContext";
import { hasModulePermission } from "../utils/permissionUtils";

export const useModulePermission = (moduleName: string) => {
  const { user } = useAuth();

  const can = (action: "read" | "write" | "update" | "upload" | "delete") =>
    hasModulePermission(user, moduleName, action);

  return { can };
};
